"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PhotomapsDotComConfig_dev_1 = __importDefault(require("./PhotomapsDotComConfig.dev"));
const config = Object.assign(Object.assign({}, PhotomapsDotComConfig_dev_1.default), { stage: "local", photomapsApi: {
        url: "http://localhost:4033"
    } });
exports.default = config;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGhvdG9tYXBzRG90Q29tQ29uZmlnLmxvY2FsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL1Bob3RvbWFwc0RvdENvbUNvbmZpZy5sb2NhbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDRGQUE4QztBQUc5QyxNQUFNLE1BQU0sbUNBQ1AsbUNBQUcsS0FDTixLQUFLLEVBQUUsT0FBTyxFQUNkLFlBQVksRUFBRTtRQUNaLEdBQUcsRUFBRSx1QkFBdUI7S0FDN0IsR0FDRixDQUFDO0FBQ0Ysa0JBQWUsTUFBTSxDQUFDIn0=